// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../engines/components/BaseComponent";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class EscortGoods1Item extends BaseComponent {

	@property({ type: cc.Node, displayName:'' })
	nodeGold: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeAd: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelAward: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelPrice: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	spr_item_1: cc.Sprite = null;

    private eId: string = null;
    private csvInfo: any = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(
            CsvFileKind.CsvFile.ESCORT_GOODS1
            , this.eId
        );

        this.initUI();
    }

    setData(
        eId: string
    ) {
        this.eId = eId;
    }

    initUI() {

        this.refreState();    
	
        let award = this.csvInfo.award;
        let price = this.csvInfo.price;
        this.labelAward.string = data_control.getNumberFormat((Number(award) || 0));
        this.labelName.string = this.csvInfo.name;
        this.labelPrice.string = data_control.getNumberFormat((Number(price) || 0));


        this.spr_item_1.node.active = false;
        let path = "res/" + this.csvInfo.icon;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.escortGoods1Bundle).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.spr_item_1.node.active = true;
                    this.spr_item_1.spriteFrame = imgs;
                }
            }
        );

    }

    refreState() {
        let idx = Number(this.eId)-1;
        let gameData = NormalGameManager._instance.getGameData();
        let count = gameData.escortGoodsEnterCount[idx] || 0;
        let limitCount = Number(this.csvInfo.every_day_count);

        this.nodeGold.active = false;
    	this.nodeAd.active = false;
        if (limitCount <= count) {
            this.nodeAd.active = true;
        } else {
            this.nodeGold.active = true;
        }
    }

    onClickEnter() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        if (this.nodeAd.active) {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.openGame();
            },()=>{
    
            },null,"广告进入押镖1");
        } else {
            let price = Number(this.csvInfo.price);
            if ( O1HD.getServices().userSrv.getCoins() < price) {
                O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node);
                NormalGameManager._instance.openBankPage();
                return;
            }

            let idx = Number(this.eId)-1;
            let gameData = NormalGameManager._instance.getGameData();
            gameData.escortGoodsEnterCount[idx] = (gameData.escortGoodsEnterCount[idx] || 0) + 1;
            NormalGameManager._instance.writeGameData();

            O1HD.getServices().userSrv.setCoins(-price, true);
            this.refreState();
            this.openGame();
        }
    }

    openGame() {
        utilsView.openPopupLayer(
            'prefab/EscortGoods1GameLayer'
            , BUNDLE_SMALL_NAME.escortGoods1Bundle
            , null
            , {
                id: this.eId
            }
            , UI_Z_INDEX.DIALOG
        )
    }

    // update (dt) {}
}
